import { CurationResponse } from '../types/curation';
import apiClient from './config';
import { getCurrentLanguage } from '../config/languageConfig';
import { buildQueryString } from './utils';
import { createCacheKey, getCacheData, setCacheData } from './cacheUtils';

/**
 * 큐레이션 목록 가져오기
 * @param lat 위도
 * @param lng 경도
 * @returns 큐레이션 응답 데이터
 */
export const getCurations = async (lat: number, lng: number): Promise<CurationResponse> => {
  try {
    // 현재 설정된 언어 가져오기
    const currentLang = getCurrentLanguage();
    
    // 쿼리 파라미터와 엔드포인트
    const endpoint = '/api/v1/curations';
    const params = { 
      lat: lat.toString(), 
      lng: lng.toString(), 
      lang: currentLang 
    };
    
    // 캐시 키 생성
    const cacheKey = createCacheKey(endpoint, params);
    
    // 캐시된 데이터 확인
    const cachedData = getCacheData<CurationResponse>(cacheKey, currentLang);
    if (cachedData) {
      return cachedData;
    }
    
    // 쿼리 파라미터 생성
    const queryString = buildQueryString(params);
    
    // API 요청에 언어 파라미터 추가
    const response = await apiClient.get(`${endpoint}${queryString}`);
    
    // 응답 데이터 캐싱
    const curationData = response.data;
    setCacheData(cacheKey, curationData, currentLang);
    
    return curationData;
  } catch (error) {
    console.error('큐레이션 가져오기 실패:', error);
    // API 실패 시 빈 응답 반환
    return {
      curationResults: {
        isEmpty: true,
        totalCategories: 0,
        allResults: [],
        totalStores: 0
      },
      language: getCurrentLanguage(),
      requestMetadata: {
        latitude: lat.toString(),
        longitude: lng.toString(),
        limit: 70
      },
      jjajangStores: [],
      chickenStores: [],
      bibimbapStores: []
    };
  }
}; 